// dados ficticios para poc de relatorio
function getLines(limit) {
  const data = {
    data: [],
    total: 17,
  }

  for (let i = 1; i <= limit; i++) {
    let desc
    let value = getRandomInt(-10, 30).toFixed(2)
    const negative = value < 0
    value = `${negative ? '- ' : ''}R$ ${value.toString().replace('-', '')}`

    if (getRandomInt(0, 10) < 5) {
      desc = 'Banqueta artmix alta hidraulica'
    } else {
      desc = 'Cadeira mor laranja leve com lavanca'
    }

    data.data.push({
      request_date: '04/12/2020',
      store: '45 - SÃO LUIZ',
      region: 'Região PR',
      lm: '88586547',
      description: desc,
      description2: desc,
      section: `0${i} - DECORAÇÃO`,
      requesting: 'Montagem',
      quantity: getRandomInt(-5, 10).toFixed(2).toString().replace('-', '- '),
      ammount: value,
    })
  }

  return data
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export { getLines }
